<script>
/**
 * @description In order to address the 'ax bug' resulting from the combination of the Tooltip component and the Radio component within ZoomUI.
 */
import ToolTip from '@zoom/zoom-ui/src/components/tooltip/tooltip.vue';

export default {
  name: 'opc-tooltip',
  extends: ToolTip,
  mounted() {
    this.hasClickEvent = this.checkClickEvent() || this.isRadioComponent();
  },
  methods: {
    hasFocusableComponent() {
      const instance = this.$slots.default[0].componentInstance;
      return instance && (instance.focus || instance.$el.focus);
    },
    isRadioComponent() {
      if (this.$slots.default && this.$slots.default.length) {
        const { elm } = this.getFirstElement();
        if ([...elm.classList].includes('zm-radio')) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
